export const severity_success: string = 'success';
export const severity_info: string = 'info';
export const severity_warning: string = 'warn';
export const severity_error: string = 'error';
